import Vue from 'vue'
import amplitude from 'amplitude-js'
import router from '../router'

const config = {
  includeUtm: false,
  includeReferrer: false
}

amplitude.getInstance().init(process.env.VUE_APP_AMPLITUDE_KEY, null, config)
Vue.prototype.$amplitude = amplitude

router.afterEach((to, from) => {
  // console.log(to, Vue.prototype.$amplitude)
  // Log pageView event
  Vue.prototype.$amplitude.getInstance().logEvent('pageView', {
    name: to.name,
    path: to.path,
    // fullPath: to.fullPath,
    params: to.params,
    query: to.query
  })
})
